import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { PageBackHeader } from './components/PageBackHeader';
import { PageBackHeaderPrimary } from './components/PageBackHeaderPrimary';

export type PageHeaderProps = {
  children: ReactNode;
};

const Header = styled('header')({
  borderBottom: '1px solid var(--color-neutral-300)',
  display: 'flex',
  alignItems: 'center',
  height: 47,
});

export const PageHeader = ({ children }: PageHeaderProps) => {
  return <Header>{children}</Header>;
};

PageHeader.Back = PageBackHeader;
PageHeader.BackWithPageTitle = PageBackHeaderPrimary;
